import React, { Fragment, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import { Provider } from "react-redux";
import { loadUser } from "./actions/auth";
import { LoadingProvider } from "./components/LoadingContext";
import Work from "./work";
import TagManager from "react-gtm-module";
import store from "./store";
import setAuthToken from "./utils/setAuthToken";
import { checkAndSetReferralCode } from "./utils/referral";
import deleteExpiredCart from "./utils/ExpiredCart";
import PrivateRoute from "./components/routing/PrivateRoute";
import history from "./components/routing/history";
import ScrollToTop from "./utils/scrollToTop";

import i18n from "./i18n";

import PageNotFound from "./components/404page/PageNotFound";

//ADMIN - OLD
import AdminDashboard from "./components/admin/admindashbord/AdminDashboard";
import DriversList from "./components/admin/drivers/DriversList";
import ResourceSchedulePage from "./components/admin/schedule/ResourceSchedulePage";
import VehicleList from "./components/admin/vehicles/VehicleList";
import BookingList from "./components/admin/booking/BookingList";
import AbandentCartList from "./components/admin/abandentcarts/AbandentCartList";
import BookingCalendar from "./components/admin/booking/BookingCalendar";
import AddDriver from "./components/admin/drivers/AddDriver";
import AddUser from "./components/admin/adminusers/AddUser";
import CreateBooking from "./components/admin/booking/CreateBooking";
import AddVehicle from "./components/admin/vehicles/AddVehicle";
import AddVehicleType from "./components/admin/vehicletype/AddVehicleType";
import VehicleTypeList from "./components/admin/vehicletype/VehicleTypeList";
import VehicleInfo from "./components/admin/vehicles/VehicleInfo";
import AdminLogin from "./components/admin/login/AdminLogin";
import UpdateVehicle from "./components/admin/vehicles/UpdateVehicle";
import UpdateDriver from "./components/admin/drivers/UpdateDriver";
import UpdateVehicleType from "./components/admin/vehicletype/UpdateVehicleType";
import CancelRescheduleRequest from "./components/admin/cancelreschedulerequest/CancelRescheduleRequestList";
import ManageCancelRescheduleRequest from "./components/admin/cancelreschedulerequest/ManageCancelRescheduleRequest";
import Garage from "./components/admin/garage/GarageList";
import AddGarage from "./components/admin/garage/AddGarage";
import UpdateGarage from "./components/admin/garage/UpdateGarage";
import "./custom.css";
import ManageBooking from "./components/admin/booking/ManageBooking";
import ManageBookingV2 from "./components/admin/booking/ManageBookingV2";
import AdminModificationHistoryPage from "./components/admin/booking-modification-history";
import AdminModificationHistoryDetailPage from "./components/admin/booking-modification-history/detail";
import AdminUserList from "./components/admin/adminusers/AdminUserList";
import IndividualUserList from "./components/admin/individualusers/IndividualUserList";
import IndividualDetail from "./components/admin/individualusers/IndividualDetail";
import BusinessUserList from "./components/admin/businessusers/BusinessUserList";
import InvoiceList from "./components/admin/invoices/InvoiceList";
import InvoiceDetail from "./components/admin/invoices/InvoiceDetail";
import BusinessUserDetail from "./components/admin/businessusers/BusinessDetail";
import UpdateUserAdmin from "./components/admin/adminusers/UpdateUserAdmin";
import Settings from "./components/admin/settings/Settings";
import AddPackage from "./components/admin/pakages/AddPackage";
import PackageList from "./components/admin/pakages/PackageList";
import UpdatePackage from "./components/admin/pakages/UpdatePackage";
import AddAirport from "./components/admin/airport/AddAirport";
import AirportList from "./components/admin/airport/AirportList";
import UpdateAirport from "./components/admin/airport/UpdateAirport";
import AddPackageNew from "./components/admin/pakages/AddPackageNew";
import AddCategory from "./components/admin/category/AddCategory";
import CategoryList from "./components/admin/category/CategoryList";
import UpdateCategory from "./components/admin/category/UpdateCategory";
import NewPackageList from "./components/admin/pakages/NewPackageList";
import UpdateNewPackage from "./components/admin/pakages/UpdateNewPackage";
import CreateBookingNew from "./components/admin/booking/CreateBookingNew";
import AddEmailTemplate from "./components/admin/emailtemplate/AddEmailTemplate";
import TemplateList from "./components/admin/emailtemplate/TemplateList";
import UpdateEmailTemplate from "./components/admin/emailtemplate/UpdateEmailTemplate";
import CMSIndex from "./components/admin/cms/CMSIndex";
import CMSAirportTransfer from "./components/admin/cms/CMSAirportTransfer";
import CMSWeddingAniversary from "./components/admin/cms/CMSWeddingAniversary";
import CMSPrivateTour from "./components/admin/cms/CMSPrivateTour";
import CMSExecutiveTansfer from "./components/admin/cms/CMSExecutiveTansfer";
import CMSFleet from "./components/admin/cms/CMSFleet";
import CMSPricing from "./components/admin/cms/CMSPricing";
import CMSAlphard from "./components/admin/cms/CMSAlphard";
import CMSGranace from "./components/admin/cms/CMSGranace";
import CMSHiaceGrandCabin from "./components/admin/cms/CMSHiaceGrandCabin";
import CMSHiaceLuxuryCabin from "./components/admin/cms/CMSHiaceLuxuryCabin";
import CMSMaps from "./components/admin/cms/CMSMaps";
import CMSHanedaAirport from "./components/admin/cms/CMSHanedaAirport";
import CMSNaritaAirport from "./components/admin/cms/CMSNaritaAirport";
import CMSTokyoStation from "./components/admin/cms/CMSTokyoStation";
import CMSCancellationPolicy from "./components/admin/cms/CMSCancellationPolicy";
import CMSCareers from "./components/admin/cms/CMSCareers";
import CMSCorporate from "./components/admin/cms/CMSCorporate";
import CMSCart from "./components/admin/cms/CMSCart";
import CMSTerms from "./components/admin/cms/CMSTerms";
import CMSHanedaAirportTransfer from "./components/admin/cms/CMSHanedaAirportTransfer";
import CMSNaritaAirportTransfer from "./components/admin/cms/CMSNaritaAirportTransfer";
import CMSContact from "./components/admin/cms/CMSContact";
import CMSCheckOut from "./components/admin/cms/CMSCheckOut";
import GarageList from "./components/admin/garage/GarageList";

import ReferralList from "./components/admin/referral/ReferralList";
import AddReferral from "./components/admin/referral/AddReferral";
import UpdateReferral from "./components/admin/referral/UpdateReferral";

//FRONTPAGES-OLD
import ForgotPassword from "./pages/front-pages/forgot-password";
import ResetPassword from "./pages/front-pages/reset-password";
import ChangePaymentMethod from "./pages/front-pages/change-payment-method";
import ChangePaymentMethodUser from "./pages/front-pages/change-payment-method-user";
import SuccessChangePaymentMethod from "./pages/front-pages/success-change-payment-method";

//REFACTORED URL
//FRONTPAGES
import Index from "./pages/front-pages";
import NewCheckout from "./pages/front-pages/checkout";
import AirportTransferPage from "./pages/front-pages/airport-transfer";
import ExecutiveTransfer from "./pages/front-pages/executive-transfer";
import Fleet from "./pages/front-pages/fleet";
import Pricing from "./pages/front-pages/pricing";
import NaritaAirportTransfer from "./pages/front-pages/narita-airport-transfer";
import AirportMaps from "./pages/front-pages/maps";
import Corporate from "./pages/front-pages/corporate";
import Careers from "./pages/front-pages/careers";
import CancellationPolicy from "./pages/front-pages/cancellation-policy";
import Contact from "./pages/front-pages/contact";
import Gads from "./pages/front-pages/gads";
import Terms from "./pages/front-pages/terms";
import HiddenCancellationPolicy from "./pages/front-pages/hidden-cancellation-policy";

import DiscoverPage from "./pages/front-pages/discover";
import BookingConfirmationPage from "./pages/front-pages/booking-confirmation";
import NewCart from "./pages/front-pages/cart";
import PaymentSuccess from "./pages/front-pages/payment-success";

import CustomerLoginPage from "./pages/front-pages/login";
import CustomerRegisterPage from "./pages/front-pages/register";
import BusinessRegisterPage from "./pages/front-pages/business-register";
import EmailVerification from "./pages/front-pages/emailverification";
import CustomerMyPage from "./pages/front-pages/my-page";
import BookingDetailPage from "./pages/front-pages/booking-detail";
import BookingDetailModificationHistoryPage from "./pages/front-pages/booking-detail-modification-history";
import BookingDetailModificationHistoryDetailPage from "./pages/front-pages/booking-detail-modification-history-detail";
import BookingEditPage from "./pages/front-pages/booking-edit";
import BookingEditReviewPage from "./pages/front-pages/booking-edit/components/BookingEditReview";
import NotificationPage from "./pages/front-pages/notification";
import NotificationDetailPage from "./pages/front-pages/notification-detail";
import { QuotationLinkPage } from "./pages/front-pages/quotation";
import ChangeEmail from "./pages/front-pages/change-email";
import ChangeEmailVerification from "./pages/front-pages/change-email-verification";
import RevertChanges from "./pages/front-pages/revert-changes";
import ChangePassword from "./pages/front-pages/change-password";

//NEW PAGE
import QuotationPage from "./components/admin/quotation/Page";
import CreateQuotationPage from "./components/admin/quotation/CreateQuotationPage";
import ModificationRequestPage from "./components/admin/modification-requests";
import ModificationRequestDetailPage from "./components/admin/modification-request-detail";
import BookingEditAdminPage from "./components/admin/booking-edit";
import Transfer from "./components/admin/quotation/Transfer";
import ComponentPage from "./components/admin/components/Page";
// import { QuotationLinkPage } from "./components/admin/quotation/QuotationLinkPage";
import QuotationDownloadPage from "./components/admin/quotation/QuotationDownloadPage";
import MemorandumPage from "./pages/front-pages/memorandum";
import ServicesPage from "./pages/front-pages/services";
import FleetTypePage from "./pages/front-pages/fleet-types";
import AboutPage from "./pages/front-pages/about";

if (localStorage.token) {
  setAuthToken(localStorage.token);
}

if (localStorage.cart) {
  deleteExpiredCart();
}

// phase 1 completed.
// Defined here rather than inline in the route table: PrivateRoute renders
// `component`, so an arrow function would be a fresh component type on every
// render and remount the page.
const DriverSchedulePage = (props) => <ResourceSchedulePage {...props} resource="driver" />;
const VehicleSchedulePage = (props) => <ResourceSchedulePage {...props} resource="vehicle" />;

const App = ({ props }) => {
  const gtm_id = "GTM-NG5F2C4V";
  // const gtm_id = "GTM-MMKDDMVW";
  // const gtm_id = "GTM-MMKDJKJHAS";

  useEffect(() => {
    checkAndSetReferralCode()
    const tagManagerArgs = {
      gtmId: gtm_id,
    };

    TagManager.initialize(tagManagerArgs);

    if (history.location.pathname.includes("/")) {
      // store.dispatch(loadUser());
    }
    if (history.location.pathname.includes("admin")) {
      store.dispatch(loadUser());
    }
    if (history.location.pathname.includes("my-page")) {
      store.dispatch(loadUser());
    }
    if (history.location.pathname.includes("booking-detail")) {
      store.dispatch(loadUser());
    }
  }, []);

  return (
    <Provider store={store}>
      <LoadingProvider>
        <Router history={history}>
          <ScrollToTop />
          <Fragment>
            <section>
              <Switch>
                {/* 3. Root Redirect - This is where the 'en' bug usually lives */}
                <Route exact path="/">
                  {() => {
                    // Get "EN" or "JP" from storage, default to "JP"
                    const savedLang = localStorage.getItem("lang") || "JP";
                    // Redirect to lowercase "/en" or "/jp"
                    return <Redirect to={`/${savedLang.toLowerCase()}/`} />;
                  }}
                </Route>

                <Route path="/:lng(en|jp)">
                  {({ match }) => {
                    const urlLng = match?.params.lng;

                    // Sync i18n if URL changed (e.g. user manually typed /en)
                    if (urlLng && i18n.language !== urlLng) {
                      i18n.changeLanguage(urlLng);
                    }

                    return (
                      <Switch>
                        <Route exact path="/:lng/" component={Index} />
                        {/* <Route exact path="/:lng/work" component={Work} /> */}
                        <Route exact path="/:lng/book" component={DiscoverPage} />
                        <Route exact path="/:lng/fleet" component={Fleet} />
                        <Route exact path="/:lng/pricing" component={Pricing} />
                        <Route
                          exact
                          path="/:lng/services"
                          component={ServicesPage}
                        />
                        <Route exact path="/:lng/fleet-types" component={FleetTypePage} />
                        <Route
                          exact
                          path="/:lng/cancellation-policy"
                          component={CancellationPolicy}
                        />
                        <Route exact path="/:lng/Maps" component={AirportMaps} />
                      </Switch>
                    );
                  }}
                </Route>

                <Route
                  exact
                  path="/change-payment-method/:token"
                  component={ChangePaymentMethod}
                />
                <Route
                  exact
                  path="/change-payment-method-user/:token"
                  component={ChangePaymentMethodUser}
                />
                <Route
                  exact
                  path="/success-change-payment-method"
                  component={SuccessChangePaymentMethod}
                />
                <Route exact path="/login" component={CustomerLoginPage} />
                <Route
                  exact
                  path="/register"
                  component={CustomerRegisterPage}
                />
                <Route
                  exact
                  path="/business-register"
                  component={BusinessRegisterPage}
                />
                <Route
                  path="/booking-confirmation"
                  component={BookingConfirmationPage}
                />
                <Route
                  exact
                  path="/emailverification/:token"
                  component={EmailVerification}
                />
                <Route exact path="/corporate" component={Corporate} />
                <Route exact path="/Cart" component={NewCart} />
                <Route exact path="/Careers" component={Careers} />
                <Route
                  exact
                  path="/Narita-airport-transfer"
                  component={NaritaAirportTransfer}
                />
                                                                                                                <Route exact path="/gads" component={Gads} />
                <Route
                  exact
                  path="/airport-transfer"
                  component={AirportTransferPage}
                />
                                <Route
                  exact
                  path="/executive-transfer"
                  component={ExecutiveTransfer}
                />
                <Route exact path="/contact" component={Contact} />
                <Route exact path="/terms" component={Terms} />
                <Route exact path="/Checkout" component={NewCheckout} />
                <Route
                  exact
                  path="/PaymentSuccess/:stripe_ref"
                  component={PaymentSuccess}
                />
                <Route
                  exact
                  path="/forgot-password"
                  component={ForgotPassword}
                />
                <Route
                  exact
                  path="/reset-password/:token"
                  component={ResetPassword}
                />
                <Route
                  exact
                  path="/quotation/:quotationId"
                  component={QuotationLinkPage}
                />
                <Route
                  exact
                  path="/change-email-verification/:token"
                  component={ChangeEmailVerification}
                />
                <Route
                  exact
                  path="/revert-changes/:token"
                  component={RevertChanges}
                />
                <Route
                  exact
                  path="/Gm8YlH7QUsw"
                  component={MemorandumPage}
                />
                <Route
                  exact
                  path="/corporate-cancellation-policy"
                  component={HiddenCancellationPolicy}
                />
                <Route exact path="/about" component={AboutPage} />
                <PrivateRoute
                  exact
                  path="/my-page"
                  component={CustomerMyPage}
                  redirectTo="/login"
                />
                <PrivateRoute
                  exact
                  path="/my-page/bookings"
                  component={CustomerMyPage}
                  redirectTo="/login"
                />
                <PrivateRoute exact path="/my-page/quotations" component={CustomerMyPage} redirectTo="/login" />
                <PrivateRoute
                  exact
                  path="/my-page/invoices-billings"
                  component={CustomerMyPage}
                  redirectTo="/login"
                />
                <PrivateRoute
                  exact
                  path="/my-page/notifications"
                  component={CustomerMyPage}
                  redirectTo="/login"
                />
                <PrivateRoute
                  exact
                  path="/my-page/notifications/:notif_id"
                  component={CustomerMyPage}
                  redirectTo="/login"
                />
                <PrivateRoute
                  exact
                  path="/notifications"
                  component={NotificationPage}
                  redirectTo="/login"
                />
                <PrivateRoute
                  exact
                  path="/notifications/:notif_id"
                  component={NotificationDetailPage}
                  redirectTo="/login"
                />
                <PrivateRoute
                  exact
                  path="/my-page/account"
                  component={CustomerMyPage}
                  redirectTo="/login"
                />
                <PrivateRoute
                  exact
                  path="/my-page/change-email/:token"
                  component={ChangeEmail}
                  redirectTo="/login"
                />
                <PrivateRoute
                  exact
                  path="/my-page/change-password/:token"
                  component={ChangePassword}
                  redirectTo="/login"
                />
                <PrivateRoute
                  exact
                  path="/booking-detail/:id"
                  component={BookingDetailPage}
                  redirectTo="/login"
                />
                <PrivateRoute
                  exact
                  path="/booking-detail/:id/modification-history"
                  component={BookingDetailModificationHistoryPage}
                  redirectTo="/login"
                />
                <PrivateRoute
                  exact
                  path="/booking-detail/:id/modification-history/:requestId"
                  component={BookingDetailModificationHistoryDetailPage}
                  redirectTo="/login"
                />
                <PrivateRoute
                  exact
                  path="/booking/:id/edit"
                  component={BookingEditPage}
                  redirectTo="/login"
                />
                <PrivateRoute
                  exact
                  path="/booking/:id_booking/edit/review"
                  component={BookingEditReviewPage}
                  redirectTo="/login"
                />
                {/* Redirect routes for airport pages with query parameters */}
                <Route
                  exact
                  path="/narita-airport"
                  render={({ location }) => {
                    const params = new URLSearchParams(location.search);
                    const t = params.get('t');
                    window.location.href = `/en/maps?type=narita-airport&t=${t}`;
                    return null;
                  }}
                />
                <Route
                  exact
                  path="/haneda-airport"
                  render={({ location }) => {
                    const params = new URLSearchParams(location.search);
                    const t = params.get('t');
                    const tParam = t === '2' ? '2-intl' : t;
                    window.location.href = `/en/maps?type=haneda-airport&t=${tParam}`;
                    return null;
                  }}
                />

                <Route path="/admin" render={() => (
                  <Switch>
                    <Route exact path="/admin" component={AdminLogin} />

                    <PrivateRoute
                      exact
                      path="/admin/categorylist/edit/:id"
                      component={UpdateCategory}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/categorylist"
                      component={CategoryList}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/addcategory"
                      component={AddCategory}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/airportlist/edit/:id"
                      component={UpdateAirport}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/addairport"
                      component={AddAirport}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/airportlist"
                      component={AirportList}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/packagelist"
                      component={PackageList}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/newpackagelist"
                      component={NewPackageList}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/settings"
                      component={Settings}
                    />
                    <PrivateRoute exact path="/admin/adduser" component={AddUser} />
                    <PrivateRoute
                      exact
                      path="/admin/addpackage"
                      component={AddPackageNew}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/useredit/edit/:id"
                      component={UpdateUserAdmin}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/packagelist/edit/:id"
                      component={UpdatePackage}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/newpackagelist/edit/:id"
                      component={UpdateNewPackage}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/dashboard"
                      component={AdminDashboard}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/driverlist"
                      component={DriversList}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/vehiclelist"
                      component={VehicleList}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/driverlist/:id/schedule"
                      component={DriverSchedulePage}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/vehiclelist/:id/schedule"
                      component={VehicleSchedulePage}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/vehicletypelist"
                      component={VehicleTypeList}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/garagelist"
                      component={GarageList}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/bookinglist"
                      component={BookingList}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/abandentcartlist"
                      component={AbandentCartList}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/addvehicle"
                      component={AddVehicle}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/addvehicletype"
                      component={AddVehicleType}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/addgarage"
                      component={AddGarage}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/vehicleinfo"
                      component={VehicleInfo}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/bookingcalendar"
                      component={BookingCalendar}
                    />
                    {/* The path was misspelled "calander" until Aug 2026 —
                        bookmarks and old links still land here. */}
                    <Route
                      exact
                      path="/admin/bookingcalander"
                      render={() => <Redirect to="/admin/bookingcalendar" />}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/addemailtemplate"
                      component={AddEmailTemplate}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/adddriver"
                      component={AddDriver}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/createbooking"
                      component={CreateBooking}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/createbookingnew"
                      component={CreateBookingNew}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cancel-reschedule-request"
                      component={CancelRescheduleRequest}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cancel-reschedule-request/manage/:id"
                      component={ManageCancelRescheduleRequest}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/vehicletypelist/edit/:id"
                      component={UpdateVehicleType}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/garagelist/edit/:id"
                      component={UpdateGarage}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/vehiclelist/edit/:id"
                      component={UpdateVehicle}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/driverlist/edit/:id"
                      component={UpdateDriver}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/bookinglist/edit/:id"
                      component={ManageBooking}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/bookinglist/edit/v2/:id/modification-history/:requestId"
                      component={AdminModificationHistoryDetailPage}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/bookinglist/edit/v2/:id/modification-history"
                      component={AdminModificationHistoryPage}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/bookinglist/edit/v2/:id"
                      component={ManageBookingV2}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/templatelist"
                      component={TemplateList}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/templatelist/edit/:id"
                      component={UpdateEmailTemplate}
                    />

                    <PrivateRoute exact path="/admin/referrallist" component={ReferralList} />
                    <PrivateRoute exact path="/admin/addreferral" component={AddReferral} />
                    <PrivateRoute exact path="/admin/referrallist/edit/:id" component={UpdateReferral} />

                    <PrivateRoute exact path="/admin/userlist-business" component={BusinessUserList} />
                    <PrivateRoute exact path="/admin/userlist-business/:id" component={BusinessUserDetail} />

                    <PrivateRoute exact path="/admin/invoices" component={InvoiceList} />
                    <PrivateRoute exact path="/admin/invoices/:id" component={InvoiceDetail} />

                    <PrivateRoute exact path="/admin/userlist-admin" component={AdminUserList} />

                    <PrivateRoute exact path="/admin/userlist-individual" component={IndividualUserList} />
                    <PrivateRoute exact path="/admin/userlist-individual/:id" component={IndividualDetail} />

                    {/* CMS routing */}
                    <PrivateRoute
                      exact
                      path="/admin/cms/cmsindex"
                      component={CMSIndex}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-airport-transfer"
                      component={CMSAirportTransfer}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-weddings-anniversaries"
                      component={CMSWeddingAniversary}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-private-tour"
                      component={CMSPrivateTour}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-executive-transfer"
                      component={CMSExecutiveTansfer}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-fleet"
                      component={CMSFleet}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-pricing"
                      component={CMSPricing}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-alphard"
                      component={CMSAlphard}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-granace"
                      component={CMSGranace}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-hiace-grand-cabin"
                      component={CMSHiaceGrandCabin}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-hiace-grand-cabin"
                      component={CMSHiaceGrandCabin}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-hiace-luxury-cabin"
                      component={CMSHiaceLuxuryCabin}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-maps"
                      component={CMSMaps}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-haneda-airport"
                      component={CMSHanedaAirport}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-narita-airport"
                      component={CMSNaritaAirport}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-tokyo-station"
                      component={CMSTokyoStation}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-cancellation-policy"
                      component={CMSCancellationPolicy}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-careers"
                      component={CMSCareers}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-corporate"
                      component={CMSCorporate}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-cart"
                      component={CMSCart}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-terms"
                      component={CMSTerms}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-haneda-airport-transfer"
                      component={CMSHanedaAirportTransfer}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-narita-airport-transfer"
                      component={CMSNaritaAirportTransfer}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-contact"
                      component={CMSContact}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/cms/cms-checkout"
                      component={CMSCheckOut}
                    />

                    <PrivateRoute
                      exact
                      path="/admin/quotations"
                      component={QuotationPage}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/modification-requests"
                      component={ModificationRequestPage}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/modification-requests/:id"
                      component={ModificationRequestDetailPage}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/booking-edit"
                      component={BookingEditAdminPage}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/quotations/create"
                      component={CreateQuotationPage}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/quotations/create/transfer"
                      component={Transfer}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/quotations/create/:quotationId"
                      component={CreateQuotationPage}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/quotations/create/:quotationId/transfer"
                      component={Transfer}
                    />
                    <PrivateRoute
                      exact
                      path="/admin/quotations/download/:quotationId"
                      component={QuotationDownloadPage}
                    />

                    <PrivateRoute
                      exact
                      path="/admin/components"
                      component={ComponentPage}
                    />

                  </Switch>
                )} />

                <Route path="*" component={PageNotFound} />
              </Switch>
            </section>
          </Fragment>
        </Router>
      </LoadingProvider>
    </Provider>
  );
};

export default App;
